<div class="row g-3 mt-1">
    <div class="col-md-6">
        <label class="form-label">{{labelPrefix}} Date:*</label>
        <dx-date-box
            [(value)]="date"
            type="date"
            stylingMode="filled"
            class="date-input"
            [displayFormat]="dateFormat" 
            [min] = "applyStandardTimeLimits ? minDate : null"
            (onValueChanged)="onDateChanged()"
            [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-date-box>
    </div>
    <div class="col-md-6">
        <label class="form-label">{{labelPrefix}} Time:*</label>
        <dx-date-box
            [(value)]="date"
            type="time"
            [pickerType]="'list'"
            [interval]="15"
            [min]="minTime"
            [max]="maxTime"
            displayFormat="hh:mm a"
            stylingMode="filled"
            class="time-input"
            (onValueChanged)="valueChanged()"
            [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-date-box>
        @if (showAppointmentCount) {
            <div class="d-inline-flex align-items-center mt-1">
                <span class="form-label me-2 pt-2">Current HDC Approved:</span>
                <span class="badge bg-danger-subtle text-danger rounded-2 px-2 py-1">
                    {{appointmentCount}}
                </span>
            </div>
        }
    </div>
</div>